import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20artistic%20collage%20background%2C%20vibrant%20illustration%20style%20with%20dynamic%20characters%20silhouettes%2C%20warm%20coral%20and%20amber%20gradient%20color%20palette%2C%20modern%20Korean%20digital%20art%20aesthetic%2C%20soft%20bokeh%20lights%2C%20artistic%20and%20atmospheric%20composition%2C%20clean%20and%20elegant%20style&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
        alt="韩漫网 - 热门韩国漫画在线阅读平台"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
            免费韩漫大全
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
            汇聚全网热门韩国漫画，每日更新最新韩漫资源，畅享正版韩漫阅读体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即阅读
            </Link>
            <Link
              to="/category/fantasy"
              className="px-8 py-3 border border-background-50/30 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10">
            {[
              { label: '漫画总数', value: '500+' },
              { label: '日更新量', value: '30+' },
              { label: '累计读者', value: '200万+' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-accent-400">{stat.value}</div>
                <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}